import { render, staticRenderFns } from "./economy-company-budget.vue?vue&type=template&id=6d6c6b71&scoped=true"
import script from "./economy-company-budget.vue?vue&type=script&lang=js"
export * from "./economy-company-budget.vue?vue&type=script&lang=js"
import style0 from "./economy-company-budget.vue?vue&type=style&index=0&id=6d6c6b71&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d6c6b71",
  null
  
)

export default component.exports